import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import customLabelApi, {
  CustomLabelData,
  CustomLabelPrintRequest
} from '../apis/customLabel.api'
import printService from '../services/print.service'
import confirmService from '../services/confirm.service'
import { ConfirmParams } from '../components/Confirm/Confirm.state'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import InputText from '../components/InputText'
import PageHeading from '../components/PageHeading'
import Row from '../components/Row/Row'
import CustomLabelInfo from '../partials/CustomLabelInfo'
import { i18n } from '../i18n/i18n'
import { WatermarkHelper } from '../components/WatermarkHelper'

interface RouteState {
    id: number
}

interface Props extends RouteComponentProps<any, any, RouteState> {
}

interface State {
    amount: string
    customLabel: CustomLabelData | null
}

class CustomLabelPrint extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      amount: '',
      customLabel: null
    }
  }

  get id () {
    return this.props.location.state.id
  }

  get heading () {
    const { customLabel } = this.state
    const nameText = customLabel ? `: ${customLabel.name}` : ''
    return `${i18n('Custom label print')}${nameText}`
  }

  handleInputChange = (name: string, value: string) => {
    if (name === 'amount') {
      this.setState({ amount: value })
    }
  }

  handlePrintConfirm = async () => {
    const { amount } = this.state

    const payload: CustomLabelPrintRequest = {}
    if (amount) payload.amount = Number(amount)

    customLabelApi.print(this.id, payload, async (markups) => {
      if (!markups) return

      markups = await WatermarkHelper.applyWatermarks(markups)

      printService.printMarkups(markups)
    })
  }

  handlePrintClick = () => {
    const confirm: ConfirmParams = {
      id: 1,
      question: i18n('Are you sure to print the labels?'),
      confirmText: i18n('Yes'),
      cancelText: i18n('No'),
      onConfirm: () => this.handlePrintConfirm()
    }
    confirmService.push(confirm)
  }

  read = () => {
    customLabelApi.read(this.id, customLabel => {
      if (!customLabel) return
      this.setState({ customLabel })
    })
  }

  componentDidMount () {
    this.read()
  }

  render () {
    return (
            <ContentLayout>
                <ContentMain layout="twoThird">
                    <Card>
                        <PageHeading text={this.heading}/>
                        <Row column={3}>
                            <InputText
                                label={i18n('Amount')}
                                name="amount"
                                value={this.state.amount}
                                onChange={this.handleInputChange}/>
                        </Row>
                        <CardButton
                            proceedText={i18n('Print')}
                            cancelText={i18n('Back')}
                            onProceedClick={this.handlePrintClick}>
                        </CardButton>
                    </Card>
                </ContentMain>
                <ContentMain layout="oneThird">
                    <CustomLabelInfo customLabel={this.state.customLabel}/>
                </ContentMain>
            </ContentLayout>
    )
  }
}

export default withRouter(CustomLabelPrint)
